import invariant from 'tiny-invariant';

import { useAppContext } from 'business/contextProviders/useAppContext';
import {
  useGraphSetDispatch,
  useGraphSet,
} from 'business/data-analysis/pages/graph/hooks/graph-context/contexts';
import { GraphSetDispatchActions } from 'business/data-analysis/pages/graph/hooks/graph-context/types';
import { useGraphSetDataDispatch } from 'business/data-analysis/pages/graph/hooks/graph-data-context/contexts';
import { GraphSetDataDispatchActions } from 'business/data-analysis/pages/graph/hooks/graph-data-context/types';
import { useGetGraphValues } from 'business/data-analysis/pages/graph/hooks/use-get-graph-values';
import { useMode } from 'business/data-analysis/pages/graph/hooks/use-mode';
import { useQueryParams } from 'business/data-analysis/pages/graph/hooks/use-query-params';
import { GraphFilters } from 'business/data-analysis/pages/graph/types';

export const useGenerateGraphs = (filters: GraphFilters) => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site id');

  const mode = useMode();

  const dispatchGraphSet = useGraphSetDispatch();
  const dispatchGraphSetData = useGraphSetDataDispatch();

  const graphSet = useGraphSet();

  const queryParams = useQueryParams(
    currentConstructionSite.id,
    filters,
    graphSet,
  );

  const { getUpdatedGraphByMode, isFetching } = useGetGraphValues(queryParams);

  const generateGraphs = async () => {
    dispatchGraphSet({
      type: GraphSetDispatchActions.UpdateLoadingStatus,
      isLoading: true,
    });
    try {
      const generateGraphsResponse = await getUpdatedGraphByMode(mode);
      dispatchGraphSetData({
        type: GraphSetDataDispatchActions.UpdateValues,
        values: generateGraphsResponse?.values ?? [],
      });
    } finally {
      dispatchGraphSet({
        type: GraphSetDispatchActions.UpdateLoadingStatus,
        isLoading: false,
      });
    }
  };

  return { generateGraphs, isFetching };
};
